import { render, staticRenderFns } from "./Voyage.vue?vue&type=template&id=fe68d352&scoped=true"
import script from "./Voyage.vue?vue&type=script&lang=js"
export * from "./Voyage.vue?vue&type=script&lang=js"
import style0 from "./Voyage.vue?vue&type=style&index=0&id=fe68d352&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe68d352",
  null
  
)

export default component.exports